export function getMaintenanceReferrerComponentId(
  originComponentId: string | null | undefined,
  targetComponentId: string
): string | null {
  // Omit a matching origin; an empty origin means View all.
  return originComponentId === targetComponentId ? null : (originComponentId ?? '');
}
